
<template>
  <div>
      <div style="padding: 0px; position: relative; top: 5vh; max-width: 600px; width: 100%; margin: 0 auto;">
        <a href="javascript: void(0)" 
          @click="toggleForm"
          style="padding: 10px; 
            border: 1px solid #383838; 
            border-radius: 25%; 
            font-size: 18px; 
            font-family: 'Roboto', sans-serif; 
            background-color: white;
            text-decoration: none !important;
            color: black; position: relative; top: 10px; left: 92%;">
          {{formVisible ? 'X' : ''}}
        </a>
        <div v-if="isFormVisible" >
          <div v-if="formURL" class="ctct-inline-form" :data-form-id="formURL">
              &nbsp;
          </div>
          <div v-else class="ctct-inline-form" data-form-id="eb37d816-0382-43ae-b962-7c0a7a0214a2">WIN A 2023 KIA SOUL</div>
        </div>
              <Home :style="{marginTop: isFormVisible ? '-80%' : '0%'}"/>

      </div>
  </div>
</template>

<script>
import Home from './Home.vue'

export default {
  components: {Home},
  props: ['formURL'],
  data() {
    return {
      formVisible: true
    }
  },
  computed: {
    isFormVisible() {
      return this.formVisible
    }
  },
  methods: {
    toggleForm() {
      if(!this.isFormVisible) {
          window.location.reload()
      } else {
        this.formVisible = !this.formVisible
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Contact.vue